export enum Lang {
  fr = "fr",
  en = "en",
  nl = "nl",
}
